module.exports = __webpack_public_path__ + "static/media/banner-previw.59976ef6.png";